import { map, compact } from 'lodash';
import type { IAccountIntegrationsLoanQToken } from './AccountIntegrationsLoanQToken.interface';

export default class AccountIntegrationsLoanQToken implements IAccountIntegrationsLoanQToken {
  id: string;
  fl: Array<string>;

  static build = (data: IAccountIntegrationsLoanQToken) =>
    new AccountIntegrationsLoanQToken(data);

  static blank = () => new AccountIntegrationsLoanQToken();

  /**
   * Constructor
   * @param {IAccountIntegrationsLoanQToken} data
   */
  constructor(data?: IAccountIntegrationsLoanQToken) {
    this.id = data?.id;
    this.fl = compact(map(data?.fl, (obj) => String(obj))) || [];
  }
}
